import { render, staticRenderFns } from "./ProductDetailMinimum.vue?vue&type=template&id=6761fe24&scoped=true"
import script from "./ProductDetailMinimum.vue?vue&type=script&lang=js"
export * from "./ProductDetailMinimum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6761fe24",
  null
  
)

export default component.exports